import { render, staticRenderFns } from "./expertDatabase.vue?vue&type=template&id=cd9df00e&scoped=true&"
import script from "./expertDatabase.vue?vue&type=script&lang=js&"
export * from "./expertDatabase.vue?vue&type=script&lang=js&"
import style0 from "./expertDatabase.vue?vue&type=style&index=0&id=cd9df00e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9df00e",
  null
  
)

export default component.exports